/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTTAXDIRECTIVETYPE = {
    Par2B: 'PAR2',
    Irp3: 'IRP3',
    FixedRate: 'FR',
    Art18DoubleTaxation: 'ART18',
    Correction: 'COR',
    Section9: 'S9',
    Paye: 'PAYE'
} as const;
export type IAPTTAXDIRECTIVETYPE = typeof IAPTTAXDIRECTIVETYPE[keyof typeof IAPTTAXDIRECTIVETYPE];


export function IAPTTAXDIRECTIVETYPEFromJSON(json: any): IAPTTAXDIRECTIVETYPE {
    return IAPTTAXDIRECTIVETYPEFromJSONTyped(json, false);
}

export function IAPTTAXDIRECTIVETYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTTAXDIRECTIVETYPE {
    return json as IAPTTAXDIRECTIVETYPE;
}

export function IAPTTAXDIRECTIVETYPEToJSON(value?: IAPTTAXDIRECTIVETYPE | null): any {
    return value as any;
}

